import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiConnectionService {

  apiUrl = 'https://api-carreravirtual.recaudia.com/'

  constructor(private http: HttpClient) { }

  // GET Methods

  getQuantities(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'race/search', conditions)
  }

  getTopDonors(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'race/search-participants', conditions)
  }

  getCollectors(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'collector/search', conditions)
  }

  getTeamInfo(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'team/search', conditions)
  }

  getPages(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'url_link/search', conditions)
  }

  getRaceAmounts(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'amount/search', conditions)
  }

  getContactInfo(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'contact/search', conditions)
  }

  getZipCode(zipCode) {
    let _ = this;
    return _.http.get(_.apiUrl + 'invoice/searchZipcode/' + zipCode)
  }

  getPlans(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'plan/search', conditions)
  }

  getMerchantDesign(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'merchant/search', conditions)
  }
  // Send methods

  createDonor(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'donor/create', conditions)
  }

  createTransaction(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'transaction/pagar', conditions)
  }

  sendReceivedPayment(conditions){
    let _ = this;
    return _.http.post(_.apiUrl + 'transaction/recibe_pago_tasf', conditions)
  }

  createTransactionOnOneStep(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'transaction/reg_pago_tasf', conditions)
  }

  createCollector(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'collector/create', conditions)
  }

  createInvoice(conditions) {
    let _ = this;
    return _.http.post(_.apiUrl + 'invoice/create', conditions)
  }

  createLogin(conditions){
    let _ = this;
    return _.http.post(_.apiUrl + 'user/signin', conditions)
  }

  updateCollector(conditions){
    let _ = this;
    return _.http.put(_.apiUrl + 'collector/update', conditions)
  }

  getTaxRegimens(paypalUniqueData){
    const _ = this;
    return _.http.post(_.apiUrl + 'invoice/tax-regime', paypalUniqueData)
  }
}
